import React from "react";
import { Helmet } from "react-helmet";
import cn from "classnames";

//assets
import background from "assets/images/sbs-landing-background.png";

import styles from "./Accessibility.module.scss";

export default function Accessibility() {
  return (
    <>
      <Helmet>
        <title>Accessibility - Small Business Search</title>
      </Helmet>

      <div className={styles["accessibility-root"]}>
        <div className={styles["background"]}>
          <img src={background} alt="background" />
        </div>

        <div className={styles["content"]}>
          <h1 className={styles["heading"]}>Accessibility statement</h1>

          <p className={cn(styles["paragraph"], styles["mt-6"])}>
            The U.S. Small Business Administration (SBA) is committed to
            providing accessible electronic information technology to
            individuals with disabilities, members of the public, and federal
            employees. We comply by the{" "}
            <a
              href="https://www.section508.gov/manage/laws-and-policies/"
              target="_blank"
              rel="noreferrer"
            >
              IT Accessibility Laws and Policies | Section508.gov
            </a>{" "}
            and we meet Level AA standards. We also conform to the{" "}
            <a
              href="https://www.w3.org/WAI/standards-guidelines/wcag/"
              target="_blank"
              rel="noreferrer"
            >
              World Wide Web Consortium (W3C)
            </a>{" "}
            and their industry standard{" "}
            <a
              href="https://www.w3.org/WAI/standards-guidelines/wcag/"
              target="_blank"
              rel="noreferrer"
            >
              Web Content Accessibility Guidelines (WCAG) 2.0
            </a>
            . We continually modify our websites to ensure the information,
            features and content are accessible to persons with disabilities.
          </p>

          <h2 className={cn(styles["sub-heading"], styles["mt-6"])}>
            Section 508 program manager
          </h2>

          <p className={cn(styles["paragraph"], styles["mt-6"])}>
            Janice MacLean, can be reached at{" "}
            <a href="mailto:508@sba.gov">508@sba.gov</a>
          </p>

          <h2 className={cn(styles["sub-heading"], styles["mt-6"])}>
            508 Complaint Process
          </h2>

          <p className={cn(styles["paragraph"], styles["mt-6"])}>
            If you have trouble accessing any resources or content on this site,
            please send an email to{" "}
            <a href="mailto:508complaints@sba.gov">508complaints@sba.gov</a> and
            include:
          </p>

          <ul className={cn(styles["list"], styles["mt-4"])}>
            <li>The nature of your accessibility issue</li>
            <li>The URL of the page the inaccessible content was found on</li>
            <li>The device and browser you are using to access the website</li>
            <li>The assistive technology you are using if any</li>
            <li>
              The preferred format in which you want to receive any materials,
              and
            </li>
            <li>Your contact information (email, phone, or address)</li>
          </ul>

          <p className={cn(styles["paragraph"], styles["mt-4"])}>
            We are committed to delivering accessible content that addresses
            your issues.
          </p>

          <h2 className={cn(styles["sub-heading"], styles["mt-6"])}>
            Requesting reasonable accommodations
          </h2>

          <p className={cn(styles["paragraph"], styles["mt-6"])}>
            We offer reasonable accommodations for federal employees and job
            applicants, consistent with Section 501 of the Rehabilitation Act.{" "}
            <a
              href="https://www.sba.gov/document/sop-37-17-1-reasonable-accommodation-personal-assistance-service-policy-procedure"
              target="_blank"
              rel="noreferrer"
            >
              Reasonable Accommodation and Personal Assistance Service Policy
              and Procedure | U.S. Small Business Administration (sba.gov)
            </a>
          </p>

          <h2 className={cn(styles["sub-heading"], styles["mt-6"])}>
            Telecommunications Relay Services (TRS)
          </h2>

          <p className={cn(styles["paragraph"], styles["mt-6"])}>
            <b>Dial 711</b> to access TRS services.
          </p>

          <p className={cn(styles["paragraph"], styles["mt-4"])}>
            <b>Telecommunications Relay Services (TRS)</b> allow persons who are
            deaf, hard of hearing, deafblind, or have speech disabilities to
            communicate by telephone in a manner that is functionally equivalent
            to telephone services used by persons without such disabilities.
          </p>

          <p className={cn(styles["paragraph"], styles["mt-4"])}>
            For a detailed list of services supported via TRS, review the{" "}
            <a href="https://www.fcc.gov/trs" target="_blank" rel="noreferrer">
              List of TRS Services (FCC.gov)
            </a>
          </p>

          <p className={cn(styles["paragraph"], styles["mt-4"])}>
            Updated December 2024
          </p>
        </div>
      </div>
    </>
  );
}
